/**
 * Module Card - TICKET ZKPVN1
 * 
 * Card colapsable de módulo con sus actividades.
 */

import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Edit2, Trash2, ArrowUp, ArrowDown } from 'lucide-react';
import ActivitiesEditor from './ActivitiesEditor';

const ModuleCard = ({ 
  module, 
  isFirst, 
  isLast, 
  onEdit, 
  onDelete, 
  onMoveUp, 
  onMoveDown,
  onUpdateActivities 
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
      {/* Header del módulo */}
      <div className="p-4 bg-gray-50 border-b border-gray-200">
        <div className="flex items-start justify-between">
          {/* Info del módulo */}
          <div className="flex-1">
            <div className="flex items-center gap-3">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                {isOpen ? (
                  <ChevronUp className="w-5 h-5" />
                ) : (
                  <ChevronDown className="w-5 h-5" />
                )}
              </button>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900">{module.title}</h3>
                {module.description && (
                  <p className="text-sm text-gray-600 mt-1">{module.description}</p>
                )}
                <div className="flex items-center gap-4 mt-2">
                  <span className="text-xs text-gray-500">
                    ID: <code className="bg-gray-100 px-2 py-0.5 rounded">{module.moduleId}</code>
                  </span>
                  <span className="text-xs text-gray-500">
                    {module.activities?.length || 0} actividades
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Acciones */}
          <div className="flex items-center gap-2 ml-4">
            {/* Botones de reorden */}
            <button
              onClick={onMoveUp}
              disabled={isFirst}
              className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
              title="Subir"
            >
              <ArrowUp className="w-4 h-4" />
            </button>
            <button
              onClick={onMoveDown}
              disabled={isLast}
              className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
              title="Bajar"
            >
              <ArrowDown className="w-4 h-4" />
            </button>

            {/* Editar */}
            <button
              onClick={onEdit}
              className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              title="Editar módulo"
            >
              <Edit2 className="w-4 h-4" />
            </button>

            {/* Eliminar */}
            <button
              onClick={onDelete}
              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              title="Eliminar módulo"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>

      {/* Actividades (colapsable) */}
      {isOpen && (
        <div className="p-4">
          <ActivitiesEditor
            moduleId={module.moduleId}
            activities={module.activities || []}
            onUpdateActivities={onUpdateActivities}
          />
        </div>
      )}
    </div>
  );
};

export default ModuleCard;
